import { render } from "./ImageCapture2.vue?vue&type=template&id=773c68fc&scoped=true"
import script from "./ImageCapture2.vue?vue&type=script&lang=js"
export * from "./ImageCapture2.vue?vue&type=script&lang=js"

import "./ImageCapture2.vue?vue&type=style&index=0&id=773c68fc&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773c68fc"]])

export default __exports__